/* eslint-disable no-console */
import { Wrap } from './styles';

import Layer from 'services/models/Layer';
import { getTurfedFeatures } from 'services/utils/layerUtils'; // getNonIntersectedFeatures
import { measureArea } from 'services/utils/measures';
import NoticeNotRun from 'services/utils/noticeNotRun';

import ButtonTooltip from '../../ButtonTooltip';

import { CustomModalSaveAsLayer } from 'views/MapView/components/CustomModalSaveAsLayer';

import Icon from '@map/components/Icons';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';



/**
 * Ferramenta Union
 * Uma funcionalidade usada em camadas criadas e importadas do tipo polígono
 * Com ela é possivel criar um poligo a partir da área de sobreposição comum
 * entre as feições de uma ou duas camadas selecionadas no menu de camadas.
 * Também é posśivel especificar as feições selecionando-as na tabela de atributos.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns 
 */
export const Union = ({ mapContext, isActive, setIsActive, ...props }) => {  
  const [arrSelectedLayers, setArrSelectedLayers] = useState([]);
  const [saveModalOpen, setSaveModalOpen] = useState(false);  
  const [runingUnion, setRuningUnion] = useState(false);
  const [collectionUnion, setCollectionUnion] = useState({});

  const { layers, map, addLayer, setLoadingInMap} = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
    },
  });

  const { resetForm } = formik;

  /**
   * Salva a operação realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */
  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (collectionUnion) {
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
      };

      const geoJsonLayer = L.geoJSON(collectionUnion, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );      
      layerToAdd.setLeafletLayer(geoJsonLayer);      
      let countIdFeature = 1;      
      layerToAdd.leafletLayer.eachLayer((feature) => {        
        let newFeatureProperties = {};
        newFeatureProperties.ID_GBA = countIdFeature;
        newFeatureProperties = {
          ...newFeatureProperties,
          ...feature.feature.properties,
        }        
        newFeatureProperties['Área (m²)'] = measureArea(feature.feature.geometry.coordinates, true);
        newFeatureProperties['Área (ha)'] = measureArea(feature.feature.geometry.coordinates, true) / 10000;

        feature.feature.properties = newFeatureProperties;
        
        countIdFeature++;
      });
      addLayer(layerToAdd);      
      setSaveModalOpen(false);
    }    
  }, [collectionUnion, addLayer]);

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
  }, [resetForm]);

  /**
   * Inicia procedimento para execução de union
   */
  const runUnion = useCallback(() => {      
    /**
     * Obtém as feições a serem envolvidas no processo de União
     */
    const getFeaturesToUnion = (arrSelectedLayers) => { 
      let arrAllFeatures = [];      
      let arrTurfedFeatures = [];
      let objNewProperties = {};
      let newPropertie= '';
      let countLayer = 1;
      for (let layer of arrSelectedLayers) {
        arrTurfedFeatures = getTurfedFeatures(layer, true);
        
        for (let turfedFeature of arrTurfedFeatures) {
          // Constroi novo objeto de propriedades das 
          // feições da camada alterando as keys e
          // mantendo os valores originais
          for (let kp of Object.keys(turfedFeature.properties)) {
            newPropertie = kp.substring(0, 8) + "_" + countLayer;              
            objNewProperties[newPropertie] = turfedFeature.properties[kp];              
          }
          // Redefine as propriedades
          turfedFeature.properties = objNewProperties;
          objNewProperties = {};            
        }

        arrAllFeatures.push(
          ...arrTurfedFeatures
        )

        countLayer++;
      }    

      return arrAllFeatures;
    };

    /**
     * Obtém as propriedades das camadas envolvidas na operação
     */
    const getPropertiesLayersUnion = (arrSelectedLayers) => { 
      let arrProperties = [];
      let countLayer = 1;
      for (let layer of arrSelectedLayers) {
        // Obtém as colunas de cada camada, recorta até o 8° caractere 
        // e as concatena com a respectiva sequência da camada
        for (let objCol of layer.getColumns()) {
          arrProperties.push(objCol.value.substring(0, 8) + "_" + countLayer);
        }
        countLayer++;
      }

      return arrProperties;
    };

    /**
     * Executa operação de union sobre as feições
     */
    const unionFeatures = async (arrAllFeatures, arrProperties, startTime, limitTimeExecution) => {        
      return new Promise((resolve, reject) => {  
        let currentTimeStart = performance.now();
        let arrUnitedFeatures = [];
        let arrFeaturesToNewOperationUnion = [];    
        let intersectedFeature = {};
        let featureDifferenceFirstLayer = {};
        let featureDifferenceSecondLayer = {};
        let hasIntersect = false;
        
        // Realiza operação de Union do item corrente 
        // com os próximos até que haja uma interseção
        for (let i = 0; i <= arrAllFeatures.length - 1; i++) {      
          // Verifica se há proximo elemento no array
          if (arrAllFeatures[i + 1]) {
            // Percorre demais elementos do array
            for (let iNextFeature = i + 1; iNextFeature <= arrAllFeatures.length - 1; iNextFeature++) { 
              //Verifica se passou do tempo limite de execução durante as interseções
              let currentTimeIntersect = performance.now();
              let currentTimeExecutionIntersect = currentTimeIntersect - currentTimeStart;
              currentTimeExecutionIntersect = currentTimeExecutionIntersect + startTime;        
              if (currentTimeExecutionIntersect >= limitTimeExecution) {           
                break;
              }
              // Realizar interseção         
              intersectedFeature = turf.intersect(arrAllFeatures[i], arrAllFeatures[iNextFeature]);
              if (intersectedFeature) {
                hasIntersect = true;            
                arrFeaturesToNewOperationUnion.push(intersectedFeature);            
                featureDifferenceFirstLayer = turf.difference(arrAllFeatures[i], arrAllFeatures[iNextFeature]);
                // Se não "sobrou" geometria da diferença da primeira geometria com a segunda
                // é pq a primeira estava totamente contida na segunda
                if (featureDifferenceFirstLayer) arrFeaturesToNewOperationUnion.push(featureDifferenceFirstLayer);
                featureDifferenceSecondLayer = turf.difference(arrAllFeatures[iNextFeature], arrAllFeatures[i]);
                // Se não "sobrou" geometria da diferença da segunda geometria com a primeira
                // é pq a segunda estava totamente contida na primeira
                if (featureDifferenceSecondLayer) arrFeaturesToNewOperationUnion.push(featureDifferenceSecondLayer);

                // Mantḿe propriedades da feição intersecionada e adiciona propriedades 
                // da primera e segunda feição na feição resultante da interseção
                intersectedFeature['properties'] = {
                  ...arrAllFeatures[i].properties,
                  ...featureDifferenceFirstLayer?.properties,
                  ...featureDifferenceSecondLayer?.properties,
                }

                // Obtém demais elementos posteriores ao segundo elemento que foi interseccionado
                // para serem verificados posteriormente na recursão
                if (arrAllFeatures[iNextFeature + 1]) {
                  arrFeaturesToNewOperationUnion.push(
                    ...arrAllFeatures.slice(iNextFeature + 1)
                  );
                }

                // Obtém elementos que estão entre os interseccionados
                arrFeaturesToNewOperationUnion.push(
                  ...arrAllFeatures.slice(i + 1, iNextFeature)
                );

                break;
              } 
            }
          }

          if (hasIntersect) {
            break;
          }

          // Percorre array de propriedades e verifica se a feição 
          // corrente possui a mesma, se não possui adiciona com valor "-"       
          arrProperties.forEach(
            (p) => {
              if (!Object.keys(arrAllFeatures[i].properties).includes(p)) {            
                arrAllFeatures[i].properties[p] = '-';
              }
            }
          );      
          
          // Se não houve interseção mantém o elemento atual
          arrFeaturesToNewOperationUnion.push(arrAllFeatures[i])
        }
        
        let currentTimeEnd = performance.now();
        let currentTimeExecution = currentTimeEnd - currentTimeStart;
        currentTimeExecution = currentTimeExecution + startTime;
        
        if (currentTimeExecution >= limitTimeExecution) {           
          return reject(new Error('fail'));
        } else {          
          if (hasIntersect) {          
            // Executa recursivamente operação de Unão para os demais elementos  
            arrUnitedFeatures = unionFeatures(arrFeaturesToNewOperationUnion, arrProperties, currentTimeExecution, limitTimeExecution);
            arrUnitedFeatures
              .then((data) => data)  
              .catch((err) => console.error(err));  
          } else {
            // Se não houve interseção é pq não mais feições para realizer a União
            arrUnitedFeatures = arrAllFeatures;
          }
          return resolve(arrUnitedFeatures);
        }
        
      });
    };

    if (!runingUnion) {
      setRuningUnion(true);
      setLoadingInMap(true);
      // Foi necessário executar a operação de Union dentro de um setTimeout, 
      // pois o mesmo trava a aplicação, impedindo a visualização do "loading".
      setTimeout(function () {        
        let arrFeatures = getFeaturesToUnion(arrSelectedLayers);
        let arrProperties = getPropertiesLayersUnion(arrSelectedLayers);
        
        unionFeatures(arrFeatures, arrProperties, 0, 10000) // Tempo limite de 10s para execução
          .then((uf) => {            
            setCollectionUnion(turf.featureCollection(uf));
            setSaveModalOpen(true);
          })
          .catch(() => {            
            NoticeNotRun({
              title: 'Unir',
              message: 'Não foi possível realizar operação.',
              buttonText: 'OK',
            });            
          })
          .finally(() => {            
            setRuningUnion(false);
            setLoadingInMap(false);
          });       
        
      }, 300);
    }      
  }, [runingUnion, arrSelectedLayers, setLoadingInMap]); 
  
  /**
   * Verifica se as camadas do array informado é válida
   * conforme os critérios informados
   */
  const isValidLayers = (arrLayers, propertie, arrValues) => {
    let isValid = true;
    for (let layer of arrLayers) {
      if (!arrValues.includes(layer[propertie])) {
        isValid = false;
        break;
      }
    }
    return isValid;
  };
  
  /** EFFECTS */

  /**
   * Habilita ferramenta de acordo com a camada selecionada, visibilidade e tipo
   */
  useEffect(() => {
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);        
    if ((selectedLayers.length >= 2      
      && isValidLayers(selectedLayers, "type", ['importada', 'criada'])      
      && isValidLayers(selectedLayers, "dataType", ["Polygon", "MultiPolygon"]))
      ) {        
        setArrSelectedLayers(selectedLayers);
    } else {
      setArrSelectedLayers([]);
    }
  }, [layers]);

  /**
   * Desabilita ferramenta caso não haja camada selecionada
   */
  useEffect(() => {    
    if (arrSelectedLayers.length === 0 && isActive) {
      setIsActive(false);
    }
  }, [arrSelectedLayers, isActive, setIsActive]);

  /**
   * Reseta ferramenta ao ser desabilitada
   */
  useEffect(() => {
    if (!isActive) {      
      handleCloseSaveModal();      
    }
  }, [isActive, handleCloseSaveModal]);

  /**
   * Adiciona e executa um evento customizado. Ao final remove evento.
   */
  useEffect(() => {
    if (isActive && !runingUnion) {
      map.on('run-union', runUnion);
      map.fire('run-union'); 
      setIsActive(false);      
      map.off('run-union');
    }
  }, [isActive, runingUnion, map, runUnion, setIsActive]);

  return (
    <Wrap>
      <ButtonTooltip
        tooltip={Union.properties.alias}
        description={Union.properties.description}
        onClick={() => {          
          setIsActive();          
        }}
        tooltipDisabled={isActive}
        active={isActive}
        disabled={arrSelectedLayers.length === 0}
      >        
        <Icon i="map-toolbar-union"></Icon>
      </ButtonTooltip>   


        <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={<SliderColorPicker
          geometryType="Polygon"
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      />     
  
    </Wrap>
  );
};

Union.properties = {
  id: 'CPN-TB-A-UNION',
  alias: 'Unir',
  description: 'Realiza a união (junção) de feições. Selecionando duas ou mais camadas criada(s) e/ou importada(s) do tipo polígono, podendo especificar feições.',
};

export default Union;
